// @flow

import { type Card } from './types';

export function getSecurityCode(card: Card): string {
  return card.securityCode;
}
